/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --background: var(--nve-ref-border-color);
  --color: var(--nve-sys-interaction-field-color);
  --border-radius: var(--nve-ref-border-radius-sm);
  --gap: calc(var(--nve-ref-space-xxxs) / 2);
  --border: none;
  --width: max-content;
  width: var(--width);
  contain: none;
}

[internal-host] {
  border-radius: var(--border-radius);
  overflow: hidden;
  width: var(--width);
  border: var(--border);
}

.input-slot {
  background: var(--background);
  border-radius: var(--border-radius);
  flex-flow: row nowrap;
  gap: var(--gap);
}

slot[name='label'] {
  align-self: center;
}

::slotted(nve-icon-button) {
  --background: var(--nve-sys-interaction-field-background);
  --color: var(--nve-sys-support-emphasis-color);
  --border-radius: 0;
}

::slotted(nve-select) {
  --padding: 0 var(--nve-ref-size-200);
  width: fit-content;
}

::slotted([nve-control]) {
  --border-radius: 0 !important;
}

::slotted([first-control]) {
  --border-radius: var(--nve-ref-border-radius-sm) 0 0 var(--nve-ref-border-radius-sm) !important;
}

::slotted([last-control]) {
  --border-radius: 0 var(--nve-ref-border-radius-sm) var(--nve-ref-border-radius-sm) 0 !important;
}
